/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/brickwall'
export default icon
